import { useEffect } from "react"
import { identify, Identify } from "@amplitude/analytics-browser"

function trackVariant(variant: string): void {
  try {
    const event = new Identify()
    event.set("exp_sharepage_preview_variant", variant)
    identify(event)
  } catch {
    // ignore amplitude errors
  }
}

export function useFeedEnabled(hasFeedData: boolean): boolean {
  useEffect(() => {
    trackVariant(hasFeedData ? "treatment" : "control")
  }, [hasFeedData])

  return hasFeedData
}
